export const getBillingRequestHeaders = (url) => {
    const organizationId = document.body?.dataset.billingOrganizationId;
    if (!organizationId) {
        return {};
    }
    const target = new URL(url, window.location.href);
    if (target.origin !== window.location.origin
        || !target.pathname.startsWith('/api/v1/billing/')) {
        return {};
    }
    return {'X-Organization-ID': organizationId};
};
